import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { getDepartureStabilityState } from "../../utils/vesselState";
import { containerGroupedByAxis } from "../../utils/vesselWeightHelpers";
import SideWeightIndicator from "../../settings/vessel/SideWeightDistribution";

const WEIGHT_Y_AXIS_TYPE = "y_axis";

const MobileVesselLoadStability = ({ vessel, containers, terminalCall }) => {
  const { t } = useTranslation();

  const stabilityState = getDepartureStabilityState(vessel, terminalCall);
  const stability = stabilityState?.stability;

  const { z: loaded = 0 } = stability?.cog_loaded ?? {};
  const { z: maxLoaded = 0 } = stability?.cog_loaded_max ?? {};

  const hasMaximumKg = maxLoaded !== 1 && maxLoaded > 0;
  const isOverLoad = hasMaximumKg && loaded > maxLoaded;

  const draught = stabilityState?.statistics?.draught ?? 0;

  const plannedWeight = containers.reduce(
    (acc, c) => acc + Number(c.weight ?? 0) / 1000,
    0
  );

  const isStable = !isOverLoad;
  const statusColor = isStable ? "#147a3c" : "#bd2d2d";

  const containerGroupedByYAxis = useMemo(
    () => containerGroupedByAxis(vessel, containers, terminalCall, WEIGHT_Y_AXIS_TYPE),
    [vessel, containers, terminalCall]
  );

  return (
    <Box sx={{ mt: 1.5, p: 1.5, border: `1px solid ${statusColor}`, borderRadius: 2, backgroundColor: isStable ? "#f4faf6" : "#fff6f6" }}>
      {/* <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography sx={{ fontSize: "0.85rem", fontWeight: 700 }}>
          {t("stability")}
        </Typography>
        <Typography sx={{ fontSize: "0.85rem", fontWeight: 800, color: statusColor }}>
          {isStable ? t("stable", "Stable") : t("attention", "Attention")}
        </Typography>
      </Box> */}

      <Box display="flex" flexDirection="column" gap={0.5}>
        {hasMaximumKg && (
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2">{t("maxStabilityKG", "Max. stability KG")}:</Typography>
            <Typography variant="body2" fontWeight={700}>{maxLoaded.toFixed(5)}</Typography>
          </Box>
        )}
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">{t("stabilityKG", "Stability KG")}:</Typography>
          <Typography variant="body2" fontWeight={700} color={isOverLoad ? "error" : "inherit"}>
            {loaded.toFixed(5)}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">{t("totalPlannedContainerWeight", "Container weight")}:</Typography>
          <Typography variant="body2">{plannedWeight.toFixed(2)} T</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">{t("totalDraught", "Draught")}:</Typography>
          <Typography variant="body2">{draught} cm</Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={0.5}>
          <Typography variant="body2">{t("transverseWeightDistribution", "Transverse weight distribution")}:</Typography>
          <Box display="flex" justifyContent="center" gap={3}>
            <SideWeightIndicator
              vessel={vessel}
              containerWeights={containerGroupedByYAxis}
              side="port"
            />
            <SideWeightIndicator
              vessel={vessel}
              containerWeights={containerGroupedByYAxis}
              side="starboard"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileVesselLoadStability;
